import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import DatepickerDefault from "../../components/datepicker";
import UploadFiled from "../../components/fileduploader";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { DropDownInput } from "../../wrappers/selectInput";
import * as Yup from "yup";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { getMilliSecUTC } from "../../utils/EllowUtils";
import { Icon } from "@iconify/react"; 
import { Error } from "@progress/kendo-react-labels";
import { postAPI, uploadApi } from "../../api/api";
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common"
import AddProject from "../../modal/addProject";

const { v4: uuidv4 } = require("uuid");

export type ContractDetailsFormFields = {
  skills: any;
  duration: string;
  contractRate: any;
  contractStartDate: any;
  contractEndDate: any;
  billingType: any;
  currencyType: any;
  ellowRate: any;
  closedBy: any;
  supportingDocument: any;
  ellowBillingType: any;
  ellowCurrencyType: any;
  history: boolean;
  signInDate: any;
  reportingManagerName: string;
  reportingManagerEmail: string;
  projectName: any;
  candidateCompanyEmail: string;
};

interface props {
  onClose?: any;
  ClickHandler?: any;
  allocatedTo?: any;
  defaultvalues?:any;
  projectData?: any;
  jobMetadata?: any;
  contractEndDate?: any;
  addProject?: any;
  projectList?: any;
  submitAddProject?: any;
  buttonName?: string;
  closed?: any;
  terminateComment?: any;
  disableButton?: any;
  hideBtn?: any
  getProjectDetailsById?: any;
  duration?: any;
  timesheetSubmitted?: any;
  skillsList: any;
}

const validationSchema = Yup.object({
  contractRate: Yup.string().required("Field is required"),
  billingType: Yup.string().required("Field is required").nullable(),
  currencyType: Yup.string().required("Field is required").nullable(),
  ellowRate: Yup.string().required("Field is required").nullable(),
  closedBy: Yup.string().required("Field is required").nullable(),
  duration: Yup.string().required("Field is required").nullable(),
  reportingManagerName: Yup.string().required('Field is required').nullable(),
  reportingManagerEmail: Yup.string().required('Field is required').nullable(),
  projectName: Yup.object().required('Field is required').nullable()
});

const ContractDetails: React.FC<props> = ({
  onClose,
  ClickHandler,
  allocatedTo,
  defaultvalues,
  projectData,
  jobMetadata,
  contractEndDate,
  submitAddProject,
  addProject,
  projectList,
  buttonName,
  closed,
  disableButton,
  terminateComment,
  hideBtn, 
  getProjectDetailsById,
  duration,
  timesheetSubmitted,
  skillsList
}) => {

  const formOptions = {
    resolver: yupResolver(validationSchema)
  }

  const { register, handleSubmit, control, reset, setValue, formState, watch } = useForm<ContractDetailsFormFields>(formOptions);

  const [disable, setDisable] = useState<boolean>(false)
  const [disableStartDate, setDisableStartDate] = useState<boolean>(false)
  const [disableEndDate, setDisableEndDate] = useState<boolean>(false)
  const [document, setDocument] = useState<string>()
  const [ellowRateValue, setEllowRateValue] = useState<string>('');
  const [rateValue, setRateValue] = useState<string>('')
  const [contractStartdateState, setContractStartDateState] = useState('');
  const [contractEnddateState, setContractEndDateState] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errors, setErrors] = useState<{ contractStartDate?: string, contractEndDate?: string }>({ contractStartDate: "", contractEndDate: "" });
  const [addProjectModal, setAddProjectModal] = useState<boolean>(false)

  useEffect(() => { 
   
    if (defaultvalues) {        
      if (buttonName === 'Save') {
        setDisable(true)  
        setDisableStartDate(true)     
        setDisableStartDate(true) 
        setDisableEndDate(true)
      }
      // to disable startdate
      if(buttonName === 'Edit contract'){
        if(new Date(defaultvalues.contractStartDate).getFullYear() < new Date().getFullYear()){
          setDisableStartDate(true)
        }else if(new Date(defaultvalues.contractStartDate).getMonth() < new Date().getMonth()){
          setDisableStartDate(true)
        }
      }
      if (buttonName === 'Extend contract') {
        setContractStartDateState(defaultvalues.contractStartDate)
      } 
      setValue('billingType', defaultvalues.billingType) 
      setValue('currencyType', defaultvalues.currencyType)
      setValue('ellowBillingType', defaultvalues.ellowBillingType)
      setValue('ellowCurrencyType', defaultvalues.ellowCurrencyType)
      if (defaultvalues.contractRate) {
        setRateValue(defaultvalues.contractRate)
      }
      if (defaultvalues.ellowRate) {
        setEllowRateValue(defaultvalues.ellowRate)
      }
      if (defaultvalues.duration) {
        setValue('duration', defaultvalues.duration)
      }
      reset(defaultvalues)
    } 
    else {
      const skills: { id: number, name: string }[] = jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.length > 0 && jobMetadata.coreSkills.map((item: { skillId: number, skillName: string }) => {
        let value = { id: item && item.skillId, name: item && item.skillName }
        return (value)
      })
      setValue('skills', skills)
      setValue('duration', duration)
    }

    if (projectData) {
      setValue('projectName', projectData.projectName)
      setValue('reportingManagerName', projectData.reportingManagerName)
      setValue('reportingManagerEmail', projectData.reportingManagerEmail) 
      if(projectData && projectData.projectId !== null){
        setValue('projectName',{ projectId : projectData.projectId,projectName : projectData.projectName})
      }
    } 
    if(timesheetSubmitted && buttonName === 'Edit contract'){
      setDisableEndDate(true)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultvalues, jobMetadata])

  useEffect(() => {    
    
    if (disableButton) {
      setDisable(false)      
    }
  }, [disableButton])

  useEffect(() => {

    getProjectDetails(watch())

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().projectName]);
  


  const onSubmit = (data: any) => {
    
    setDisable(true)
    
    data.supportingDocument = document !== undefined ? document : ''
    if (!data.contractEndDate) {
      errors.contractStartDate = 'Field is required'
    }
    if (!data.contractEndDate) {
      errors.contractEndDate = 'Field is required'
    }
    if (data.contractEndDate && data.contractEndDate) {
      data.history = false
      ClickHandler(data);
    }
  }

  const handleChange = (event: any, value: string) => {
    if (value === "contractStartDate" || value === "contractEndDate" || value === "signInDate") {
      setValue(value, getMilliSecUTC(event.target.value));
      if(value === "contractStartDate"){
        setContractStartDateState(event.target.value)
        if(contractEnddateState){
          getMonthDifference(event.target.value, contractStartdateState)
        }
      }
      if(value === "contractEndDate"){
        setContractEndDateState(event.target.value)
        if(contractStartdateState){
          getMonthDifference(contractStartdateState, event.target.value)
        }
      }
    }
    if (value === "ellowRate") {
      setEllowRateValue(event.target.value ? Math.abs(event.target.value).toString() : "");
    }
    if (value === "rate") {
      setRateValue(event.target.value ? Math.abs(event.target.value).toString() : "")
    }
  };


  const uploadFile = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {

      let file = e.target.files[0]
      let type = file.type

      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");

      let value = {
        "action": "putObject",
        "filename": fileName
      }

      postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {
        let signedUrl = data.url;
        uploadApi(signedUrl, file, type).then((response: any) => {
          setDocument(fileName)
          setValue('supportingDocument', fileName.slice(36, fileName.length))
        })
      })
    }
  }

  const submitProjectDetails = (data: any) => {  
    setValue('projectName',{ projectId : data.projectId,projectName : data.projectName})
    setValue('reportingManagerName',data.reportingManagerName)
    setValue('reportingManagerEmail',data.reportingManagerEmail)
    submitAddProject(data)
    setAddProjectModal(false)
  }

  const addProjects = () => {
    setAddProjectModal(true)
  }

  function getMonthDifference(startDate: any, endDate: any) {
     
    let value =  `${new Date(endDate).getMonth() -
    new Date(startDate).getMonth() +
    12 * (new Date(endDate).getFullYear() - new Date(startDate).getFullYear())} Months`
    setValue('duration', value)
  }

  const getProjectDetails = (data: any) => { 
    if(data && data.projectName && data.projectName.projectId){
      getProjectDetailsById(data.projectName.projectId).then((response: any) => {
        if (response && response.status === 1) {
          setValue('reportingManagerName',response.data[0].reportingManagerName)
          setValue('reportingManagerEmail',response.data[0].reportingManagerEmail)
        }
      })
    } 
  }

  const checkEndDateMin = () => {

    if(defaultvalues && buttonName === 'Edit contract'){
      if(new Date(defaultvalues && defaultvalues.contractEndDate && defaultvalues.contractEndDate) <= new Date()){
        if( new Date(defaultvalues && defaultvalues.contractEndDate && defaultvalues.contractEndDate).getMonth() === new Date().getMonth() ){
          return new Date(new Date(defaultvalues && defaultvalues.contractEndDate && defaultvalues.contractEndDate).getFullYear(), new Date(defaultvalues && defaultvalues.contractEndDate && defaultvalues.contractEndDate).getMonth(), 1)
        }else {
          return new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        }
      }else{
          return new Date( new Date().getFullYear(), new Date().getMonth(), 1)
      }
    }
    else{
      return new Date( 2000, 1, 1)
    } 
  }

  
  
  return (
    <>
    <Modal title={"Contract Details "} size="medium" onClose={onClose}>
      {/* <form> */}
        <div className="form-group">
          <MultiDropDownInput<ContractDetailsFormFields>
            name="skills"
            placeholder="Skills"
            register={register}
            data={skillsList}
            label="Skills"
            errors={formState.errors}
            control={control}
            dataItemKey="id"
            textField="name"
            defaultValue={defaultvalues && defaultvalues.skills}
            allowCustom={false}
            disabled={disable}
          />
        </div>

        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Start Date*</label>
            <DatepickerDefault
              disabled={disableStartDate}
              onChange={(e: any) => handleChange(e, "contractStartDate")}
              defaultValue={defaultvalues !== '' ? defaultvalues && defaultvalues.contractStartDate && new Date(defaultvalues.contractStartDate) : defaultvalues.contractStartDate && new Date(jobMetadata.contractStartDate)}
            />
            <Error>{errors?.contractStartDate}</Error>
          </div>
          <div className="form-group">
            <label className="lablel">End Date*</label>
            <DatepickerDefault
              disabled={disableEndDate}
              onChange={(e: any) => handleChange(e, "contractEndDate")}
              defaultValue={ defaultvalues !== '' ? defaultvalues && defaultvalues.contractEndDate && new Date(defaultvalues.contractEndDate) : defaultvalues.contractStartDate && new Date(jobMetadata.contractEndDate) }
              min={checkEndDateMin()}
            />
            <Error>{errors?.contractEndDate}</Error>
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="duration"
              data={CONSTANTS.contractDuration}
              register={register}
              errors={formState.errors}
              control={control}
              label="Duration"
              disabled={disable}
              defaultValue='1 Month'
            />
          </div>
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="contractRate"
              type="number"
              register={register}
              errors={formState.errors}
              label="Resource Cost*"
              value={rateValue}
              placeholder="Rate"
              onchange={(e: any) => handleChange(e, "rate")}
              disabled={disable}
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="billingType"
              data={["Monthly", "Daily", "Hourly"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Time Basis*"
              disabled={disable}
            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="currencyType"
              data={["INR", "USD"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Currency Type*"
              defaultValue={defaultvalues && defaultvalues.currencyType}
              disabled={disable}
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="closedBy"
              data={allocatedTo}
              label="Position Closed By*"
              register={register}
              errors={formState.errors}
              control={control}
              defaultValue={defaultvalues && defaultvalues.closedBy}
              disabled={disable}
            />
          </div>
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="ellowRate"
              label="ellow rate*"
              type="number"
              register={register}
              value={ellowRateValue}
              errors={formState.errors}
              placeholder="Ellow Rate"
              onchange={(e: any) => handleChange(e, "ellowRate")}
              // defaultValue={ellowRate}
              disabled={disable}

            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="ellowBillingType"
              data={["Monthly", "Daily", "Hourly"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Time Basis*"
              disabled={disable}

            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="ellowCurrencyType"
              data={["INR", "USD"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Currency Type*"
              defaultValue={defaultvalues && defaultvalues.currencyType}
              disabled={disable}

            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <div className="labelWithButton">
              <label className="lablel">Project*</label>
              <Button disabled={disable} onClick={() => {addProjects()}}><Icon icon="akar-icons:plus" />Add Project</Button>
            </div>
            <DropDownInput<ContractDetailsFormFields>
              name="projectName"
              data={projectList}
              register={register}
              errors={formState.errors}
              control={control}
              // onChange={() => getProjectDetails()}
              dataItemKey="projectId"
              textField="projectName"
              disabled={disable}

            />
          </div>
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="candidateCompanyEmail"
              register={register}
              errors={formState.errors}
              label="Candidate company email"
              placeholder="Company email"
              disabled={disable}

            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="reportingManagerName"
              register={register}
              errors={formState.errors}
              label="Reporting manager name*"
              placeholder="Enter reporting manager name"
              disabled={true}
            />
          </div>
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="reportingManagerEmail"
              register={register}
              errors={formState.errors}
              label="Reporting manager email*"
              placeholder="Enter reporting manager email"
              disabled={true}

            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Sign In Date</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e, "signInDate")}
              disabled={disable}
              defaultValue={defaultvalues && defaultvalues.signInDate && new Date(defaultvalues.signInDate)}
            />
            {/* <Error>{errors?.signInDate}</Error> */}
          </div>
        </div>
        <div className="form-wrap">
          <div className="form-group">
            <label className="lablel">
              Any additional supporting document?(optional)
            </label>
            <div className="uploadWrap no-padd-dropzone">
              <FormInput<ContractDetailsFormFields>
                id="supportingDocument"
                type="text"
                name="supportingDocument"
                placeholder="Enter your services here"
                register={register}
                errors={formState.errors}
                disabled={disable}

              />
              <UploadFiled uploadFile={uploadFile} disable={disable} />
            </div>
          </div>
        </div>
        {terminateComment !== null && terminateComment !== undefined &&
          <div className="form-wrap">
            <div className="form-group">
              <label className="lablel">Reason for termination :</label>
              <div className="field autoHeight">{terminateComment}</div>
            </div>
          </div>
        }
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {  <Button variant="primary" disabled={disable} onClick={handleSubmit(onSubmit)}>
            {buttonName}
          </Button>}
        </div>
        {addProjectModal && <AddProject onClose={() => setAddProjectModal(false)} ClickHandler={submitProjectDetails}/>}
      {/* </form> */}
    </Modal>
    </>
  );
};

export default ContractDetails;
